import {
  Icon,
  IconButton,
  Notice,
  ProductCard,
  Shadow,
  Text,
  VStack as NBVStack,
  HStack as NBHStack,
} from '@genial/components';
import { Utils, useBreakpointValue } from '@genial/utils';
import { Box as NBBox } from 'native-base';
import React from 'react';

import { NormalizedDistributionProduct } from '../../../../store/managementAnalysis/types';
import { Header } from '../Header';
import { ProductSearch } from '../ProductSearch';
import { FilterButton } from '../ProductSearch/FilterButton';
import { SubItemProduct } from '../SubItemProduct';

interface ManagementAnalysisDetailsContentProps {
  information: any;
  product: NormalizedDistributionProduct;
  alertText: string;
  handleBack: () => void;
}

export const ManagementAnalysisDetailsContent = ({
  information,
  product,
  alertText,
  handleBack,
}: ManagementAnalysisDetailsContentProps) => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const isTablet = useBreakpointValue({ base: false, sm: true, lg: false });
  const subItems = product.productSubClassData || [];

  const showRefresh = false;

  const isCheckingAccount = product.productClassName === 'checking-account';

  const renderProductCard = () => {
    return (
      <ProductCard
        testId="product-card"
        loading={false}
        color={product.color}
        size={60}
        hidePercentage={isCheckingAccount}
        stackProps={isCheckingAccount ? { py: 'stack.xs' } : {}}
        valueLabelTitle={isMobile ? 'VALOR' : undefined}
        product={{
          name: product.label,
          percentage: product.productClassPercentage || 0,
          value: product.productClassValue || 0,
        }}
        rightComponent={
          !isMobile && (
            <NBHStack space="inline.quarck" pl="inline.xxxs" alignItems="center">
              <Icon
                name="Calendar"
                size="xxxs"
                testId="product-card-calendar"
                color="neutral.medium"
              />
              <Text color="neutral.medium">
                {`Atualizado em ${Utils.Mask.DateFormat(information.executionDate, 'dd/MM/yyyy')}`}
              </Text>
              {!!showRefresh && (
                <IconButton
                  p={0}
                  testId="product-card-refresh"
                  icon="Refresh"
                  iconSize="xxxs"
                  iconColor="brand.tertiary.principal"
                  onPress={() => null}
                />
              )}
            </NBHStack>
          )
        }
      />
    );
  };

  return (
    <NBVStack p="inset.xs" space="stack.xxxs" flex={1} minHeight="100%">
      <Header headerTitle={product.label} handleGoBack={handleBack} />
      {renderProductCard()}
      {!!isMobile && !!subItems.length && (
        <>
          <NBHStack justifyContent="space-between" alignItems="center">
            <Text variant="semibold">ALOCAÇÃO POR PRODUTO</Text>
            <FilterButton isMobile={isMobile} />
          </NBHStack>
          <Shadow testId="shadow" level={1} borderRadius="8px">
            <NBVStack p="inset.xs" space="inset.xs">
              {!!alertText && (
                <Notice
                  testId="notice"
                  textObjects={[{ text: alertText, variant: 'regular' }]}
                  type="alert"
                />
              )}
              <NBVStack space="inset.xs">
                {subItems.map((currentProduct, index) => (
                  <>
                    <SubItemProduct
                      key={currentProduct.productSubClass}
                      name={currentProduct.productSubClass || ''}
                      percentage={currentProduct.productSubClassPercentage}
                      value={currentProduct.productSubClassValue}
                    />
                    {index !== subItems.length - 1 && (
                      <NBBox w="full" h="1px" backgroundColor="neutral.lightest" />
                    )}
                  </>
                ))}
              </NBVStack>
            </NBVStack>
          </Shadow>
        </>
      )}
      <ProductSearch
        testId="product-search"
        isMobile={isMobile}
        isTablet={isTablet}
        product={product}
      />
    </NBVStack>
  );
};
